import { ethers } from 'ethers';
import emdmAbiJson from '../abis/emdm.abi.json';

const useMediumWallet = ({ erc20ContractAddress }) => {
  const provider = new ethers.providers.Web3Provider(window._ethereum);

  const contract = new ethers.Contract(
    erc20ContractAddress,
    emdmAbiJson,
    provider,
  );

  return {
    provider,
    signer: provider.getSigner(),
    contract,
  };
};

export default useMediumWallet;
